import React from "react";
import { LibraryItem } from "../../../entities/LibraryItem";
import { LibraryItemType } from "../../../entities/LibraryItemType";
import { AssetView } from "./AssetView";
import { EmptyState } from "./EmptyState";
import { FolderView } from "./FolderView";

interface Props {
    item?:LibraryItem;
}

export function RightDrawer(props:Props){
	const { item } = props;

	if (item) {
		return (
			<div style={{paddingLeft: 30}}>
				{
				item.type  === LibraryItemType.Folder || 
				item.type  === LibraryItemType.PremiumSermon ||
				item.type  === LibraryItemType.PremiumSermonSeries || 
				item.type  === LibraryItemType.SermonSeries
					? <FolderView item={item} />
					: <AssetView item={item} />
				}
			</div>
		)
	}

    return (
		<EmptyState />
    );
}